import { Check } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { useT } from "@/lib/i18n";

const SesionPromise = () => {
  const t = useT();
  const promises = [
    t("free.promise.1"),
    t("free.promise.2"),
    t("free.promise.3"),
    t("free.promise.4"),
  ];

  return (
    <section className="py-20 md:py-28">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-20 items-start">
        <Reveal className="md:col-span-5">
          <p className="text-[11px] tracking-[0.32em] uppercase text-sage mb-5">{t("free.promise.eyebrow")}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal leading-[1.05]">
            {t("free.promise.title1")} <span className="italic">{t("free.promise.title2")}</span>.
          </h2>
          <p className="mt-6 text-charcoal/70 leading-relaxed">
            {t("free.promise.lead")}
          </p>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-7">
          <ul className="space-y-1">
            {promises.map((p, i) => (
              <li
                key={p}
                className="flex items-start gap-4 py-5 border-b border-sand/70"
                data-testid={`promise-${i}`}
              >
                <span className="w-9 h-9 rounded-full border border-terracotta/50 flex items-center justify-center text-terracotta flex-shrink-0 mt-0.5">
                  <Check size={14} />
                </span>
                <span className="text-[16px] text-charcoal/85 leading-relaxed">{p}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};

export default SesionPromise;
